import { useState } from "react";
import "./App.css";
import PenguinCursor from "./PenguinCursor";

function App() {

  return (
    <div className="relative w-full min-h-screen bg-gray-900">
      <PenguinCursor />
      <img
        src="/banner-image.jpg"
        alt="Fong's Hot Food"
        className="fixed inset-0 w-full h-full object-cover"
      />
      <div className="relative bg-black bg-opacity-60 min-h-screen flex flex-col items-center justify-center text-white p-4 text-center">
        <p><img src="/fongsHotFood.png" alt="Fong's Hot Food logo" className="mx-auto" /></p>
        <p className="mt-3 text-center text-lg">
          <a href="/Fongs_Open_Sunday_Menu_Trifold_May_2026.pdf" target="_blank" rel="noreferrer" className="inline-block bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors">Download MENU PDF</a>
        </p>
        <div className="w-full max-w-2xl aspect-video mt-6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2374.3457343729065!2d-3.0237077999999995!3d53.4801521!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b254f936d4dc9%3A0x8787e99ef2066659!2sFong&#39;s%20Hot%20Food!5e0!3m2!1sen!2suk!4v1762431819844!5m2!1sen!2suk"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Fong's Hot Food Location"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default App;